import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { OrderService } from '../../../services/orders/order.service';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'app-ops-toolbar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './ops-toolbar.component.html',
  styleUrls: ['./ops-toolbar.component.css']
})
export class OpsToolbarComponent implements OnInit, OnDestroy {
  currentUrl = '';
  kitchenCount = 0; // 'sent'
  readyCount = 0;   // 'ready'
  foodtruckOnly = false;
  private pollId: any;

  constructor(private router: Router, private keycloak: KeycloakService, private orderService: OrderService, private config: ConfigService) {
    this.currentUrl = this.router.url || '';
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      this.currentUrl = e.urlAfterRedirects || e.url || this.router.url || '';
    });
  }

  ngOnInit(): void {
    this.updateFoodtruckFlag();
    const tick = () => this.refreshCounts();
    tick();
    this.pollId = setInterval(tick, 10000);
  }

  ngOnDestroy(): void { if (this.pollId) clearInterval(this.pollId); }

  private updateFoodtruckFlag(): void {
    try {
      const rolesA = (this.keycloak?.getUserRoles ? this.keycloak.getUserRoles() : []) as string[];
      const rolesB = (this.keycloak?.getUserRoles ? this.keycloak.getUserRoles(true) : []) as string[];
      const all = [...new Set([...(rolesA || []), ...(rolesB || [])].map(r => (r || '').toLowerCase()))];
      let hasAdmin = all.includes('admin');
      const inst: any = (this.keycloak as any)?.getKeycloakInstance?.();
      if (inst?.hasRealmRole && inst.hasRealmRole('admin')) hasAdmin = true;
      if (inst?.hasResourceRole && inst.hasResourceRole('admin')) hasAdmin = true;
      const isAdmin = !!hasAdmin;
      this.foodtruckOnly = this.config.foodtruckOnly && !isAdmin;
    } catch {
      this.foodtruckOnly = this.config.foodtruckOnly;
    }
  }

  private refreshCounts(): void {
    this.orderService.getSentOrderItems().subscribe({
      next: (items: any[]) => this.kitchenCount = Array.isArray(items) ? items.length : 0,
      error: () => { /* mantener último valor */ }
    });
    this.orderService.getReadyOrderItems().subscribe({
      next: (items: any[]) => this.readyCount = Array.isArray(items) ? items.length : 0,
      error: () => { /* mantener último valor */ }
    });
  }

  isActive(route: string): boolean {
    const url = this.currentUrl || this.router.url || '';
    return url.startsWith(route);
  }

  async logout() {
    try {
      await this.keycloak.logout(window.location.origin);
    } catch (e) {
      console.error('[OpsToolbar] Logout error', e);
    }
  }
}
